import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableSortLabel, {
  tableSortLabelClasses,
} from '@mui/material/TableSortLabel';
import styled from 'styled-components';

export const StyledTableCell = styled(TableCell)`
  &.${tableCellClasses.head} {
    background-color: #f8fafc;
    color: #334155;
    border-bottom: 1px solid #dbe3ee;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    white-space: nowrap;
  }

  &.${tableCellClasses.body} {
    font-size: 13px;
  }
`;

export const StyledTableSortLabel = styled(TableSortLabel)`
  & .${tableSortLabelClasses.icon} {
    color: #64748b !important;
  }

  &.${tableSortLabelClasses.root} {
    color: #334155 !important;
    font-weight: 700;
  }
`;
